/* eslint-disable @typescript-eslint/no-empty-interface */
import { Translations } from "src/components/molecules/modals/TranslationsModal/types";
import { PrefillRule } from "../../../components/molecules/PrefillRuleListEditor/PrefillRuleEditor";
import type { SelectItem, WhereItems } from "../../../globalTypes";
import type { ColumnFormat, ColumnLink } from "../../templates/types";

export type OrderType = "asc" | "desc" | "empty";
export enum PresentationTemplateItemType {
  Value = "value",
  SelectStatic = "selectStatic",
  OverviewSelect = "overviewSelect",
  SelectDynamic = "selectDynamic",
  Hidden = "hidden",
  HegFile = "hegFile",
  File = "file",
  AggGroup = "aggGroup",
  EwaLogin = "EwaLogin",
  EwaUsername = "ewaUsername",
  HegLogim = "hegLogin",
  HegUsermame = "hegUsername",
  Link = "link",
  Color = "color",
  Icon = "icon",
  Title = "title",
}

export interface PresentationTemplateItem {
  id: number;
  overviewSelectTemplateId: number | null;
  displayColumnName: string;
  type: PresentationTemplateItemType;
  selectItems: SelectItem[];
  aggregationGroupId: number | null;
  columnFormat: ColumnFormat;
  columnFormatMobile: ColumnFormat;
  columnLink: ColumnLink | null;
  editable: boolean;
  disableTriggerEvents: boolean;
  columnOrder: number;
  prefillRules: PrefillRule[];
  overviewSelectPrefillRules: WhereItems;
  translations: Translations;
}

export interface DetailPresentationTemplateItem
  extends PresentationTemplateItem {
  hiddenAttributeConditions: WhereItems;
  editableAttributeConditions: WhereItems;
}

export interface OverviewPresentationTemplateItem
  extends PresentationTemplateItem {
  sortOrder: number | null;
  sortType: OrderType;
}

export interface ItemPresentationTemplateItem extends PresentationTemplateItem {
  sortOrder: number | null;
  sortType: OrderType;
}

interface NotificationPresentationTemplateItem
  extends PresentationTemplateItem {}

export interface DbDetailPresentationTemplateItem
  extends DetailPresentationTemplateItem {}

export interface DbItemPresentationTemplateItem
  extends ItemPresentationTemplateItem {}

export interface DbOverviewPresentationTemplateItem
  extends OverviewPresentationTemplateItem {}

export interface DbNotificationPresentationTemplateItem
  extends NotificationPresentationTemplateItem {}

export interface HegDetailPresentationTemplateItem
  extends DetailPresentationTemplateItem {}

export interface HegItemPresentationTemplateItem
  extends ItemPresentationTemplateItem {}

export interface HegOverviewPresentationTemplateItem
  extends OverviewPresentationTemplateItem {}

export interface HegNotificationPresentationTemplateItem
  extends NotificationPresentationTemplateItem {}

export type AllPresentationTemplateItems =
  | DbDetailPresentationTemplateItem
  | DbItemPresentationTemplateItem
  | DbOverviewPresentationTemplateItem
  | DbNotificationPresentationTemplateItem
  | HegDetailPresentationTemplateItem
  | HegItemPresentationTemplateItem
  | HegOverviewPresentationTemplateItem
  | HegNotificationPresentationTemplateItem;
